import { render, staticRenderFns } from "./ModalCreatePage.vue?vue&type=template&id=b3a7e644&scoped=true&"
import script from "./ModalCreatePage.vue?vue&type=script&lang=js&"
export * from "./ModalCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreatePage.vue?vue&type=style&index=0&id=b3a7e644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a7e644",
  null
  
)

export default component.exports